import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
  FormControlName,
} from '@angular/forms'
import { QuoteDataService } from '../../services/quote-data.service'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { AuthService } from '@spartacus/core'
import { BillToAddress } from '../../model/address-models'
import { NgSelectComponent } from '@ng-select/ng-select'
import { QuoteCheckoutService } from '../../services/quote-checkout.service'
import { environment } from '../../../../../../environments/environment'
import { CommonService } from '../../../../../shared/services/common.service'

@Component({
  standalone: false,
  selector: 'vs-sold-to-address',
  templateUrl: './sold-to-address.component.html',
  styleUrls: ['./sold-to-address.component.scss'],
})
export class SoldToAddressComponent implements OnInit {
  @Input() isSubmitted = false
  @Input() count = 1
  @Input() billToAddress: BillToAddress
  @Output() billToAddressUpdate = new EventEmitter<BillToAddress>()
  @Input() validationGroup = 'bill-to'
  @ViewChild('countryFocus') countryFocus: NgSelectComponent

  @ViewChild('stateFocus') stateFocus: NgSelectComponent
  soldToAddress: FormGroup
  selectedCountry
  countryNames: any
  isSoldToAddressChecked = false
  k: FormGroup
  countryRegionNames: any
  isLoggedinUser: boolean
  userType: string
  cartId: string
  soldData: any
  maxVal
  countryData: any
  stateData: any
  constructor(
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private data: QuoteDataService,
    private quoteCheckoutService: QuoteCheckoutService,
    private auth: AuthService // private el: ElementRef
  ) {}
  ngOnInit(): void {
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
        this.maxVal = 40
        this.cartId = sessionStorage.getItem('cartId-current')
      } else {
        this.userType = 'anonymous'
        this.maxVal = 35
        this.cartId = sessionStorage.getItem('cartId-anonymous')
      }
    })
    this.soldToAddressFormDetails()
    this.soldToAddress.valueChanges.subscribe((data) => {
      this.data.sendBillToAddressValidation(this.soldToAddress.valid)
      this.data.setSoldAddressDataNew(data)
      this.billToAddress = {
        country: this.countryData,
        companyName: data.companyName,
        firstName: data.firstName,
        lastName: data.lastName,
        line1: data.line1,
        line2: data.line2,
        region: this.stateData,
        postalCode: data.postalCode,
        town: data.city,
      }
      this.billToAddressUpdate.emit(this.billToAddress)
    })
    this.quoteCheckoutService.checkSubmission.subscribe((data) => {
      if (data === true && this.soldToAddress.invalid) {
        this.scrollToError()
      }
    })
  }
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  scrollToError(): void {
    const firstElementWithError = document.querySelector(
      '.ng-invalid[formControlName]'
    )
    this.scrollTo(firstElementWithError)
  }
  soldToAddressFormDetails() {
    this.soldToAddress = this.formBuilder.group({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      companyName: new FormControl('', Validators.required),
      line1: new FormControl('', Validators.required),
      line2: new FormControl(''),
      country: new FormControl(null, Validators.required),
      state: new FormControl(null),
      city: new FormControl('', Validators.required),
      postalCode: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(10),
          Validators.pattern(/^[a-zA-Z0-9 -]*$/),
        ],
      ],
    })
    if (this.billToAddress) {
      this.soldToAddress.controls['firstName'].setValue(
        this.billToAddress?.firstName
      )
      this.soldToAddress.controls['lastName'].setValue(
        this.billToAddress?.lastName
      )
      this.soldToAddress.controls['line1'].setValue(this.billToAddress?.line1)
      this.soldToAddress.controls['companyName'].setValue(
        this.billToAddress?.companyName
      )
      this.soldToAddress.controls['line2'].setValue(this.billToAddress?.line2)
      this.soldToAddress.controls['country'].setValue(
        this.billToAddress?.country?.name
      )
      this.soldToAddress.controls['state'].setValue(
        this.billToAddress?.region?.name
      )
      this.soldToAddress.controls['postalCode'].setValue(
        this.billToAddress?.postalCode
      )
      this.soldToAddress.controls['city'].setValue(this.billToAddress?.town)
      this.countryData = this.billToAddress?.country
      this.stateData = this.billToAddress?.region
      this.data.sendBillToAddressValidation(this.soldToAddress.valid)
    }
    this.getCountryData()
  }

  newMessage(message) {
    this.data.setSoldAddressDataNew(this.soldToAddress.value)
  }
  get firstName() {
    return this.soldToAddress.get('firstName')
  }
  get lastName() {
    return this.soldToAddress.get('lastName')
  }
  get companyName() {
    return this.soldToAddress.get('companyName')
  }
  get line1() {
    return this.soldToAddress.get('line1')
  }
  get country() {
    return this.soldToAddress.get('country')
  }
  get state() {
    return this.soldToAddress.get('state')
  }
  get city() {
    return this.soldToAddress.get('city')
  }
  get postalCode() {
    return this.soldToAddress.get('postalCode')
  }
  getCountryData() {
    const countries = 'countries'
    const urlParam = [countries]
    const apiUrl = this.commonService.constructUrl(urlParam)
    // const apiParams = { fields: 'DEFAULT', type: 'BILLING' };
    const apiParams = { fields: 'DEFAULT' }

    this.commonService.getData(apiUrl, apiParams).subscribe(
      (success) => {
        this.countryNames = success[countries]
      },
      (error) => {}
    )
    this.data.getSoldCountry.subscribe((country) => {
      if (country) {
        this.soldToAddress.get('country').setValue(country)
      }
    })
  }
  selectState() {
    this.countryRegionNames.forEach((element) => {
      if (element.isocode === this.soldToAddress.controls['state'].value) {
        this.stateData = element
        this.billToAddress.region = element
        this.soldToAddress.controls['state'].setValue(
          this.soldToAddress.controls['state'].value
        )
      }
    })
  }
  saveCountryData() {
    this.countryNames.forEach((element) => {
      if (element.isocode === this.soldToAddress.controls['country'].value) {
        this.countryData = element
        this.billToAddress.country = element
        this.soldToAddress.controls['country'].setValue(
          this.soldToAddress.controls['country'].value || 'Select'
        )
      }
    })
    this.selectedCountry = this.soldToAddress.controls['country'].value

    if (this.selectedCountry == 'CN') {
      this.soldToAddress.controls['postalCode'].clearValidators()
    } else {
      this.soldToAddress.controls['postalCode'].setValidators([
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(10),
        Validators.pattern(/^[a-zA-Z0-9 -]*$/),
      ])
    }
    this.soldToAddress.controls['postalCode'].updateValueAndValidity()
    const regions = 'regions'
    this.commonService
      .getData(
        environment.occBaseUrl +
          environment.getCountryURL +
          this.selectedCountry +
          '/regions?fields=DEFAULT'
      )
      .subscribe(
        (success) => {
          this.countryRegionNames = success[regions]
          this.countryRegionNames = success[regions]
          if (this.countryRegionNames?.length > 0) {
            this.soldToAddress.controls['state'].setValidators([
              Validators.required,
            ])
          } else {
            this.soldToAddress.controls['state'].clearValidators()
          }
          this.soldToAddress.controls['state'].updateValueAndValidity()
        },
        (error) => {}
      )
  }
  acceptNumberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode
    if (
      charCode > 31 &&
      (charCode < 48 || charCode > 57) &&
      charCode !== 43 &&
      charCode !== 45 &&
      charCode !== 40 &&
      charCode !== 41 &&
      charCode !== 46 &&
      charCode !== 62
    ) {
      return false
    }
    return true
  }
}
